import HandbookFolder from './HandbookFolder'

export default HandbookFolder
